<template>
  <el-dialog title="抽奖明细" :visible.sync="visible" width="800px" class="lottery-details-dialog" @close="handleClose" append-to-body :close-on-click-modal="false">

    <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
      <el-table-column label="商品名称" prop="goodsName" align="center" />
      <el-table-column label="商品规格" prop="goodsSpec" align="center" />
      <el-table-column label="抽奖库存" prop="goodsCount" align="center" />
    </el-table>
    <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
  </el-dialog>
</template>

<script>
import liveBagApi from '@/api/goods/sysGoodsCategorize'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      visible: false,
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
    }
  },
  methods: {
    handleShow(row) {
      this.visible = true
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return liveBagApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleSearch() {
      // 这里只是本地过滤，实际可根据需要请求后端
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

